// React Imports
import React, { useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { IUserDocument } from "../../Models/IUserDocument";
import { baseUrl } from "../../helpers/constants";

import { IAddDocumentsToAcademyFolderDto } from "../../Models/IAddDocumentsToAcademyFolderDto";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import UserDocumentPicker from "../../Controls/DocumentPicker";

// Props
interface IAddAcademyDocumentDialogProps {
  isDialogOpen: boolean;
  onDismiss: any;
  folderGuid: string;
  academyDocumentFolder2UserDocuments: string[] | undefined;
}

// Function
function AddAcademyDocumentDialog(props: IAddAcademyDocumentDialogProps) {
  const [selectedDocuments, setSelectedDocuments] = useState<IUserDocument[]>(
    [],
  );

  const addDocumentsToAcademyDocumentFolder = () => {
    const dto: IAddDocumentsToAcademyFolderDto = {
      folderGuid: props.folderGuid,
      userDocumentGuids: selectedDocuments.map((item) => item.userObjectGuid),
    };

    fetchWrapper
      .postWithAuth(`${baseUrl}/api/academy/AddDocumentsToFolder`, dto)
      .then(() => {
        props.onDismiss();
      });
  };

  return (
    <div>
      <Dialog open={props.isDialogOpen} onOpenChange={() => props.onDismiss()}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              {i18n.t<string>("addAcademyDocumentDialogTitle")}
            </DialogTitle>
            <DialogContent>
              {i18n.t<string>("addAcademyDocumentDialogText")}
              <div>
                <UserDocumentPicker
                  currentDocuments={props.academyDocumentFolder2UserDocuments}
                  folderGuid={props.folderGuid}
                  setSelectedDocuments={function (
                    selectedDocuments: IUserDocument[],
                  ): void {
                    setSelectedDocuments(selectedDocuments);
                  }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button
                  onClick={() => {
                    props.onDismiss();
                  }}
                  appearance="secondary"
                >
                  {i18n.t<string>("cancel")}
                </Button>
              </DialogTrigger>
              <Button
                disabled={selectedDocuments && selectedDocuments.length == 0}
                onClick={() => {
                  addDocumentsToAcademyDocumentFolder();
                }}
                appearance="primary"
              >
                {i18n.t<string>("add")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

// Export Function
export default AddAcademyDocumentDialog;
